import React, { useEffect } from 'react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import RainbowText from '../components/RainbowText';
import '../styles/RainbowText.css';

const Contact = () => {
  return (
    <SubpageShell currentPath="/contact">
      <SEO
        title="Contact"
        description="Get in touch with N3URO WORLD® — strategic enquiries, infrastructure partnerships, media and family access."
        path="/contact"
      />
      <section className="subpage-hero">
        <span className="subpage-eyebrow">Contact</span>
        <h1 className="subpage-title">
          <RainbowText>Let&rsquo;s build something different — together.</RainbowText>
        </h1>
        <p className="subpage-lede">
          For partnerships, press, or general enquiries — reach the team directly.
        </p>
        <div className="subpage-rule" aria-hidden="true" />
      </section>

      <main className="subpage-main contact-main">
        <section className="contact-card-wrap" id="contact-card" data-testid="contact-card-section">
          <figure className="contact-card" data-testid="contact-card-poster">
            <img width="960" height="544" decoding="async"
              src="/img/contact-card.webp"
              alt="N3URO WORLD® — Neuro-Inclusive Family Infrastructure. Email hello@n3uro.world. Website www.n3uro.world. Instagram @n3uro_world."
              loading="eager"
            />
          </figure>
        </section>

        <section className="contact-links-wrap" aria-label="Direct contact links">
          <div className="contact-links" data-testid="contact-direct-links">
            <a
              className="contact-link contact-link--primary"
              href="mailto:hello@n3uro.world"
              data-testid="contact-email-link"
            >
              hello@n3uro.world
            </a>
            <a
              className="contact-link"
              href="https://www.instagram.com/n3uro_world"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram-link"
            >
              @n3uro_world on Instagram
            </a>
            <a
              className="contact-link"
              href="https://n3uro.world"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-website-link"
            >
              www.n3uro.world
            </a>
          </div>
        </section>
      </main>
    </SubpageShell>
  );
};

export default Contact;
